// src/pages/Dashboard.js
import React from 'react';

const Dashboard = () => (
    <div>
        <h1>Dashboard</h1>
        <p>Bu yerda dashboard mazmuni joylashadi.</p>
    </div>
);

export default Dashboard;
